/*
 * Push notification campaign history.
 *
 * A push sent straight from the Compose page leaves no row anywhere - Firebase takes it and
 * that is that - so the Campaign page keeps its own record of those here. The notifications
 * the backend stored are read as well and merged in.
 */

const STORAGE_KEY = "pushNotiCampaigns";
const MAX_RECORDS = 100;

export const readCampaigns = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

export const saveCampaign = campaign => {
  try {
    const campaigns = [campaign, ...readCampaigns()].slice(0, MAX_RECORDS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(campaigns));
    return campaigns;
  } catch (error) {
    return readCampaigns();
  }
};

export const removeCampaign = id => {
  try {
    const campaigns = readCampaigns().filter(item => item.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(campaigns));
    return campaigns;
  } catch (error) {
    return readCampaigns();
  }
};

export const clearCampaigns = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // nothing to do
  }
  return [];
};

export const makeCampaignId = () =>
  `local-${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 8)}`;
